import theme from "../../theme";
import type { InfoPageStyles } from "../../types";
import type { SxProps, Theme } from "@mui/material";

const getStyles = (): Record<InfoPageStyles, SxProps<Theme>> => {
  return {
    close: {
      position: "absolute",
      top: 0,
      left: 0,
    },

    listBox: {
      display: "flex",
      flexDirection: "column",
      alignItems: "baseline",
      padding: 0,
    },

    text: {
      mb: theme.spacing(1),
      maxWidth: 360,
    },

    avatar: { minWidth: 40 },

    icon: { height: 15 },

    group: { gap: 2, alignItems: "flex-start" },

    wrapper: { display: "table-cell" },

    control: { display: "table" },

    space: { my: 2 },

    card: {
      padding: 2,
      fontWeight: "bold",
      "@media (min-width:120px)": {
        fontSize: 12,
        fontWeight: "bold",
      },
      "@media (min-width:300px)": {
        fontSize: 14,
        fontWeight: "bold",
      },
      "@media (min-width:400px)": {
        fontSize: 16,
        fontWeight: "bold",
      },
      "@media (min-width:600px)": {
        fontSize: 18,
      },
      "@media (min-width:800px)": {
        fontSize: 18,
      },
      "@media (min-width:1000px)": {
        fontSize: 18,
      },
      "@media (min-width:1280px)": {
        fontSize: 20,
      },
    },
  };
};

export default getStyles;
